module.exports = __webpack_public_path__ + "static/locales/ms.1xDJPeG.json";